import { render, staticRenderFns } from "./V2Bid.vue?vue&type=template&id=275f57fe&scoped=true&"
import script from "./V2Bid.vue?vue&type=script&lang=js&"
export * from "./V2Bid.vue?vue&type=script&lang=js&"
import style0 from "./V2Bid.vue?vue&type=style&index=0&id=275f57fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275f57fe",
  null
  
)

export default component.exports